export const auth = (state) => state.auth;
export const loader = (state) => state.loader;
export const toast = (state) => state.toast;
export const operation_types = (state) => state.operation_types;
export const income_types = (state) => state.income_types;
export const requests = (state) => state.requests;
export const users = (state) => state.users;
